// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parcel-rules{margin-top:20px;position:relative}.parcel-rules .table-clicked th.column{padding:8px}.parcel-rules .table.table thead th{white-space:normal}.parcel-rules .table-list-opened{border-bottom:none!important;background:#fafafa}.parcel-rules .table-list-opened td,.parcel-rules .v-datatable__expand-col--expanded{background:#fafafa}.parcel-rules .v-datatable__expand-row{cursor:auto}.parcel-rules .v-datatable__expand-row i{font-size:18px}", ""]);
// Exports
module.exports = exports;
